import React from "react";
import firebase from "firebase";
import Select from "react-select";

const sexList = [
  {
    value: "M",
    label: "Male"
  },
  {
    value: "F",
    label: "Female"
  },
  {
    value: "O",
    label: "Other"
  }
];

export default class EditInfo extends React.Component {
  state = {
    studentId: this.props.modalUserInfo.studentId,
    studentName: this.props.modalUserInfo.studentName,
    studentSurname: this.props.modalUserInfo.studentSurname,
    citizenId: this.props.modalUserInfo.citizenId,
    facultyName: this.props.modalUserInfo.facultyName || "คณะนิติศาสตร์",
    facultyId: this.props.modalUserInfo.facultyId || 1,
    dressCode: this.props.modalUserInfo.dressCode || "D0101",
    prefixName: this.props.modalUserInfo.prefixName || "นาย",
    sex: this.props.modalUserInfo.sex || "M",
    email: this.props.modalUserInfo.email || "",
    phone: this.props.modalUserInfo.phone || "",
    year: this.props.modalUserInfo.year || "",
    faculties: [],
    dressCodes: []
  };

  handleSubmit() {
    const { studentId, studentName, studentSurname, citizenId, facultyId, dressCode, prefixName, sex, phone, email, year } = this.state;
    const { universityFirebase, updateTable, closeModal, modalUserInfo } = this.props;

    if (studentId != null) {
      firebase
        .database()
        .ref(`${universityFirebase}/users/${modalUserInfo.studentId}`)
        .remove()
        .then(() => {
          firebase
            .database()
            .ref(`${universityFirebase}/users/${studentId}`)
            .set({
              studentId,
              studentName,
              studentSurname,
              citizenId,
              facultyId,
              dressCode,
              prefixName,
              phone,
              email,
              sex,
              year
            })
            .then(() => {
              updateTable();
              closeModal();
            });
        });
    } else {
      alert("กรุณาใส่รหัสนักศึกษา");
    }
  }

  handleChangeSelect = (value, field) => {
    this.setState({ [field]: value.value });
  };

  componentDidMount() {
    const { universityFirebase } = this.props;

    //Get Faculties list
    firebase
      .database()
      .ref(`${universityFirebase}/faculties`)
      .once("value")
      .then(snapshot => {
        const array = Object.entries(snapshot.val());
        const faculties = array.map((item, index) => ({ value: Number(item[0]), label: item[1] }));
        faculties.unshift({ value: "all", label: "Select Filter" });
        this.setState({ faculties });
      });

    firebase
      .database()
      .ref(`${universityFirebase}/dressCodes`)
      .once("value")
      .then(snapshot => {
        const dressCodes = Object.keys(snapshot.val()).map(item => ({
          value: item,
          label: item
        }));
        this.setState({ dressCodes });
      });
  }

  render() {
    const { studentId, studentName, studentSurname, citizenId, facultyId, faculties, dressCode, dressCodes, prefixName, sex, email, phone, year } = this.state;

    return (
      <div style={{ overflow: "hiddle" }}>
        <button type="button" className="close" onClick={this.props.closeModal}>
          <span aria-hidden="true">&times;</span>
        </button>
        <br />
        <h1>Edit</h1>
        <br />
        <label>Faculty</label>
        <Select value={facultyId} options={faculties} onChange={value => this.handleChangeSelect(value, "facultyId")} />
        <br />
        <label>Dress Code</label>
        <Select value={dressCode} options={dressCodes} onChange={value => this.handleChangeSelect(value, "dressCode")} />
        <br />
        <label>
          Student ID <span style={{ color: "red" }}>*</span>
        </label>
        <input type="text" className="form-control" onChange={event => this.setState({ studentId: event.target.value })} value={studentId} />
        <br />
        <label>Prefix</label>
        <input type="text" className="form-control" onChange={event => this.setState({ prefixName: event.target.value })} value={prefixName} />
        <br />
        <label>First Name</label>
        <input type="text" className="form-control" onChange={event => this.setState({ studentName: event.target.value })} value={studentName} />
        <br />
        <label>Surname</label>
        <input type="text" className="form-control" onChange={event => this.setState({ studentSurname: event.target.value })} value={studentSurname} />
        <br />
        <label>E-mail</label>
        <input type="email" className="form-control" onChange={event => this.setState({ email: event.target.value })} value={email} />
        <br />
        <label>Phone</label>
        <input type="tel" className="form-control" onChange={event => this.setState({ phone: event.target.value })} value={phone} />
        <br />
        <label>Citizen ID</label>
        <input type="text" className="form-control" onChange={event => this.setState({ citizenId: event.target.value })} value={citizenId} />
        <br />
        <label>Sex</label>
        <Select value={sex} options={sexList} onChange={value => this.handleChangeSelect(value, "sex")} />
        <br />
        <label>Acad Year</label>
        <input type="number" className="form-control" onChange={event => this.setState({ year: event.target.value })} value={year} />
        <br />
        <div className={"text-right"}>
          <button className="btn btn-success" onClick={() => this.handleSubmit()}>
            Submit
          </button>
          &nbsp;
          <button className="btn btn-danger" onClick={this.props.closeModal}>
            Close
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /src/containers/UserManagement/EditInfo.js